import PropTypes from 'prop-types';
import classnamesBind from 'classnames/bind';
import React from 'react';
import ConcurLogo from './_ConcurLogo';
import SapConcurLogo from './_SapConcurLogo';
import SapLogo from './_SapLogo';

const Logo = (props) => {
    const {
        ariaHidden,
        className,
        cssBlock,
        isRetiredBrand,
        useSapLogo,
        styles,
        hideTitle,
        isOpusUser,
        ...otherProps
    } = props;

    const classnames = classnamesBind.bind(styles);

    const logoFillClasses = classnames(
        `${cssBlock}__logo--fill1`,
    );

    const logoFill2Classes = classnames(
        `${cssBlock}__logo--fill2`,
    );

    const logoFill3Classes = classnames(
        {
            [`${cssBlock}__logo--fill3`]: useSapLogo,
        },
    );

    const logoFill4Classes = classnames(
        {
            [`${cssBlock}__logo--fill4`]: useSapLogo,
        },
    );

    const sharedFillClasses = {
        fill1ClassName: logoFillClasses,
        fill2ClassName: logoFill2Classes,
    };

    const componentProps = {
        classnames,
        'aria-hidden': ariaHidden,
        className: classnames(className),
        ...otherProps,
    };

    if (useSapLogo) {
        return (
            <SapLogo
                {...componentProps}
                {...sharedFillClasses}
                hideTitle={hideTitle}
                fill3ClassName={logoFill3Classes}
                fill4ClassName={logoFill4Classes}
            />
        );
    }

    if (isRetiredBrand) {
        return <ConcurLogo {...sharedFillClasses} {...componentProps} hideTitle={hideTitle} />;
    }
    return (
        <div className={classnames(`${cssBlock}__logo-container`, {
            [`${cssBlock}__logo-container--opus`]: isOpusUser,
        })}
        >
            <SapConcurLogo
                {...componentProps}
                hideTitle={hideTitle}
                cssBlock={cssBlock}
                className={className}
                isOpusUser={isOpusUser}
            />
        </div>
    );
};

Logo.displayName = 'Logo';

Logo.propTypes = {
    ariaHidden: PropTypes.bool,
    className: PropTypes.string,
    cssBlock: PropTypes.string,
    isRetiredBrand: PropTypes.bool,
    useSapLogo: PropTypes.bool,
    styles: PropTypes.object,
    hideTitle: PropTypes.bool,
    isOpusUser: PropTypes.bool,
};

export default Logo;
